export const OPEN_POPUP = 'OPEN_POPUP';
export const CLOSE_POPUP = 'CLOSE_POPUP';

export const openPopup = settings => dispatch => {
  dispatch({ type: OPEN_POPUP, payload: { settings } });
};

export const closePopup = () => dispatch => {
  dispatch({ type: CLOSE_POPUP });
};
